import { useGetTaxReports } from '@/query/queries/report/useGetTaxReports';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { Preloader } from '@/components/Preloader';
import { useWindowSize } from '@/hooks/useWindowSize';
import { DesktopView } from './desktop';
import { MobileView } from './mobile';
import s from './index.module.scss';

export const DataView = ({ params }) => {
  const { isMobile } = useWindowSize();
  const { data, isLoading } = useGetTaxReports({
    date_from: params.range[0],
    date_to: params.range[1],
  });

  const isEmpty =
    !data ||
    (data &&
      !Number(data?.interest_received) &&
      !Number(data?.cash_bonuses_received) &&
      !Number(data?.non_cash_bonuses_invested) &&
      !Number(data?.non_cash_bonuses_received) &&
      !Number(data?.non_cash_bonuses_expired));

  return (
    <div className={s.wrapper}>
      {isLoading ? (
        <Preloader style={{ height: '30vh' }} />
      ) : isEmpty ? (
        <div className={s.empty}>
          <EmptyContent />
        </div>
      ) : isMobile ? (
        <MobileView data={data} />
      ) : (
        <DesktopView data={data} />
      )}
    </div>
  );
};
